import React from 'react';
import { FaFileExport } from 'react-icons/fa6';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';

import { DisabledActionTooltip } from './DisabledActionTooltip';

export interface ExportButtonProps {
	disabled?: boolean;
	disabledTooltip?: string;
	isExporting?: boolean;
	onClick(): void;
}

export function ExportButton({ disabled, disabledTooltip, isExporting, onClick }: ExportButtonProps) {
	const isDisabled = Boolean(disabled) || Boolean(isExporting);

	return (
		<DisabledActionTooltip disabled={isDisabled} tooltip={disabledTooltip}>
			<button
				type='button'
				className='flex items-center gap-1.5 h-8 px-3 rounded border border-cPurple-600 bg-cPurple-600 text-sm font-semibold text-white tracking-wide whitespace-nowrap flex-shrink-0 transition-colors hover:bg-cPurple-700 hover:border-cPurple-700 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-cPurple-600 disabled:hover:border-cPurple-600'
				disabled={isDisabled}
				onClick={onClick}
			>
				Exportovat do XLSX
				{isExporting ? (
					<SpinningLoadingIcon className='w-3 h-3 flex-shrink-0' />
				) : (
					<FaFileExport className='w-3 h-3 flex-shrink-0' />
				)}
			</button>
		</DisabledActionTooltip>
	);
}
